/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpinWheelOutcome
 */
export interface SpinWheelOutcome {
    /**
     * Display label for the wheel segment
     * @type {string}
     * @memberof SpinWheelOutcome
     */
    label: string;
    /**
     * Hex color code for the segment
     * @type {string}
     * @memberof SpinWheelOutcome
     */
    color: string;
    /**
     * Probability percentage (not shown to player)
     * @type {number}
     * @memberof SpinWheelOutcome
     */
    probability?: number;
}

/**
 * Check if a given object implements the SpinWheelOutcome interface.
 */
export function instanceOfSpinWheelOutcome(value: object): value is SpinWheelOutcome {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function SpinWheelOutcomeFromJSON(json: any): SpinWheelOutcome {
    return SpinWheelOutcomeFromJSONTyped(json, false);
}

export function SpinWheelOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelOutcome {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'color': json['color'],
        'probability': json['probability'] == null ? undefined : json['probability'],
    };
}

export function SpinWheelOutcomeToJSON(json: any): SpinWheelOutcome {
    return SpinWheelOutcomeToJSONTyped(json, false);
}

export function SpinWheelOutcomeToJSONTyped(value?: SpinWheelOutcome | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'color': value['color'],
        'probability': value['probability'],
    };
}

